import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { snackActions } from '../../sc-utilities/SnackBar';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import { hasPermission, hasAtLeastOnePermission } from '../../sc-utilities';
import LogoList from './LogoList';
import { CloudDownload, FindInPage } from '@material-ui/icons';
import { createHistory } from '../../sc-utilities';
import { download } from "../../sc-utilities/download.utils";
import config from "../../../config/config";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        paddingLeft: theme.spacing(-1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});

const Logo = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions, activeCustomer } = props;
    let visible = columns && columns['Logo'];

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, logoID: null, redirectPath: '' });
    const redirectHandler = (path, LogoID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, logoID: LogoID, redirectPath: path })
    };

    const handleDownload = async (logoID) => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/logos/download?LogoID=${logoID}&ActiveCustomerID=${activeCustomer}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    };


    const tableColumns = useMemo(() => {
        return [{
            title: translations["action"] || "Action", field: 'LogoID',
            hidden: visible ? visible['LogoID'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'logo_load') ? <Tooltip title={translations["logo_details"] || "Logo details"}>
                        <IconButton id={`edit_logo_${rowData.LogoID}`} value={rowData.LogoID} aria-label={translations["logo_details"] || "Logo details"} onClick={() => redirectHandler(`/settings/logo/edit?logoID=${rowData.LogoID}`)}>
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                        : ''
                }
                {
                    hasPermission(permissions, 'logo_download') ? <Tooltip title={translations["download_logo"] || "Download logo"}>
                        <span>
                            <IconButton id={`download_logo_${rowData.LogoID}`} aria-label={translations["download_logo"] || "Download logo"} components={'div'} value={rowData.LogoID} onClick={() => handleDownload(rowData.LogoID)}>
                                <CloudDownload />
                            </IconButton>
                        </span>
                    </Tooltip> : ''
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    if (!hasAtLeastOnePermission(permissions, ['logo_load', 'logo_download'])) {
        tableColumns.shift();
    }


    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'logo_list') ?
                <LogoList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};


export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(Logo));